import {
  Component,
  OnInit,
  ChangeDetectorRef
}
from '@angular/core';

import {
  CommonModule
}
from '@angular/common';

import {
  HttpClient
}
from '@angular/common/http';

import {
  RouterLink
}
from '@angular/router';

import { AdminNavbar }
from '../admin-navbar/admin-navbar';

@Component({
  selector: 'app-categories-list',

  standalone: true,

  imports: [
    CommonModule,
    RouterLink,
    AdminNavbar
  ],

  templateUrl:
    './categories-list.html',

  styleUrls: [
    './categories-list.scss'
  ]
})
export class CategoriesList
implements OnInit
{
  categories: any[] = [];

  loading = false;

  constructor(
    private http:
      HttpClient,

    private cdr:
      ChangeDetectorRef
  ) {}

  ngOnInit()
  {
    this.loadCategories();
  }

  loadCategories()
  {
    console.log(
      'CALLING API'
    );

    this.loading = true;

    this.http.get<any[]>(
      'https://lazzaro-api1.onrender.com/api/categories'
    )

    .subscribe({

      next: (res) =>
      {
        console.log(
          'SUCCESS'
        );

        console.log(res);

        this.categories = res;

        this.loading = false;

        this.cdr.detectChanges();

        console.log(
          'LOADING:',
          this.loading
        );

        console.log(
          'COUNT:',
          this.categories.length
        );
      },

      error: (err) =>
      {
        console.log(
          'ERROR'
        );

        console.log(err);

        this.loading = false;

        this.cdr.detectChanges();
      }
    });
  }

  deleteCategory(id: number)
  {
    const confirmed =
      confirm(
        'Delete category?'
      );

    if (!confirmed)
      return;

    this.http.delete(
      `https://lazzaro-api1.onrender.com/api/categories/${id}`
    )

    .subscribe({

      next: () =>
      {
        this.loadCategories();
      },

      error: (err) =>
      {
        console.log(err);
      }
    });
  }
}